import React, { useContext } from "react";

import type { ISessionCtx } from "./Session/SessionContext";
import SessionContext from "./Session/SessionContext";
import { isAuthenticated } from "./Utils";

type TChildFunction = (session: ISessionCtx["session"], sessionCtx: ISessionCtx) => React.ReactNode;
export interface IAuthenticatedProps {
  children?: TChildFunction | React.ReactNode;
  component?: React.ComponentType<{ session: ISessionCtx["session"]; sessionCtx: ISessionCtx }>;
  componentProps?: object;
  required?: boolean;
}

const Authenticated = (props: IAuthenticatedProps) => {
  const { required = true, children: origChildren, component, componentProps } = props;
  const sessionCtx = useContext(SessionContext);
  const { loading, session } = sessionCtx;

  // While the session is loading this component renders nothing.
  // If you wish to render a component during loading use withSession()
  // or the Authenticating component
  if (!loading && (!required || (required && isAuthenticated(session)))) {
    /**
     * Render prioritization
     * 1. Function-as-child
     * 2. props.component
     * 3. Whatever was passed as props.children
     */
    if (typeof origChildren === "function") {
      const renamedChildFunctionToMakeTypeScriptUnderstand = origChildren as TChildFunction;
      return <React.Fragment>{renamedChildFunctionToMakeTypeScriptUnderstand(session, sessionCtx)}</React.Fragment>;
    }

    if (component) {
      return React.createElement(component, { session, sessionCtx, ...componentProps });
    }

    return <React.Fragment>{origChildren}</React.Fragment>;
  }

  return null;
};

export default Authenticated;
